const initialState = {
    prismicContentLoading: false,
    prismicContentLoaded: false,
    prismicContent: [],
    eventsLoading: false,
    eventsLoaded: false,
    geoLocationEnabled: false,
    events: [],
};

function app(state = initialState, action) {
    switch (action.type) {
        case 'HOMEPAGE_CONTENT_V2:FETCH_CONTENT_REQUEST':
            return {
                ...state,
                prismicContentLoading: true,
            };
        case 'HOMEPAGE_CONTENT_V2:FETCH_CONTENT_SUCCESS':
            return {
                ...state,
                prismicContentLoading: false,
                prismicContentLoaded: true,
                prismicContent: action.data,
            };
        case 'HOMEPAGE_CONTENT_V2:FETCH_CONTENT_FAILURE':
            return {
                ...state,
                prismicContentLoading: false,
                prismicContentLoaded: false,
                prismicContent: action.data,
            };
        case 'HOMEPAGE_CONTENT_V2:FETCH_EVENTS_REQUEST':
            return {
                ...state,
                eventsLoading: true,
            };

        case 'HOMEPAGE_CONTENT_V2:FETCH_EVENTS_SUCCESS_WITH_GEOLOCATION':
            return {
                ...state,
                geoLocationEnabled: true,
                eventsLoading: false,
                eventsLoaded: true,
                events: action.data,
            };
        case 'HOMEPAGE_CONTENT_V2:FETCH_EVENTS_SUCCESS_WITHOUT_GEOLOCATION':
            return {
                ...state,
                geoLocationEnabled: false,
                eventsLoading: false,
                eventsLoaded: true,
                events: action.data,
            };

        default:
            return state;
    }
}

export default app;
